export const BUTTON_KIND = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
}

export const BUTTON_SHAPE = {
  default: "default",
  pill: "pill",
  circle: "circle",
}

export const BUTTON_TYPE = {
  button: "button",
  submit: "submit",
  reset: "reset",
}

export const BUTTON_OVERRIDE_TYPE = {
  BaseButton: "BaseButton",
  StartEnhancer: "StartEnhancer",
  ButtonText: "ButtonText",
  EndEnhancer: "EndEnhancer",
}
